import { render } from "./annotationTips.vue?vue&type=template&id=9c32f8da&scoped=true"
import script from "./annotationTips.vue?vue&type=script&lang=js"
export * from "./annotationTips.vue?vue&type=script&lang=js"

import "./annotationTips.vue?vue&type=style&index=0&id=9c32f8da&scoped=true&lang=scss"
import "./annotationTips.vue?vue&type=style&index=1&id=9c32f8da&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c32f8da"]])

export default __exports__